module.exports = __webpack_public_path__ + "static/media/search.98cd81f1.svg";